import { convertPtBR } from "@/i18n/ptBR";

/**
 * BR storefront only: rewrites PT-PT vocabulary left hardcoded in pages
 * (outside i18n) to PT-BR. Internal areas are skipped.
 */
const INTERNAL = /^\/(admin|crm|contabilidade|armazem|compras|burocracia|assistencia|ia|hexa)/;
const SKIP_TAGS = new Set(["SCRIPT", "STYLE", "TEXTAREA", "INPUT", "CODE", "PRE"]);

function fixNode(n: Node) {
  if (n.nodeType === Node.TEXT_NODE) {
    const v = n.nodeValue || "";
    if (!v.trim()) return;
    const out = convertPtBR(v);
    if (out !== v) n.nodeValue = out;
    return;
  }
  if (n.nodeType !== Node.ELEMENT_NODE) return;
  const el = n as HTMLElement;
  if (SKIP_TAGS.has(el.tagName) || el.isContentEditable) return;
  for (const attr of ["placeholder", "title", "aria-label", "alt"]) {
    const v = el.getAttribute(attr);
    if (v) { const o = convertPtBR(v); if (o !== v) el.setAttribute(attr, o); }
  }
  el.childNodes.forEach(fixNode);
}

export function startPtBRDom() {
  if (typeof window === "undefined") return;
  const active = () => !INTERNAL.test(window.location.pathname);
  const obs = new MutationObserver((muts) => {
    if (!active()) return;
    for (const m of muts) {
      if (m.type === "characterData") fixNode(m.target);
      else m.addedNodes.forEach(fixNode);
    }
  });
  const start = () => {
    if (active()) fixNode(document.body);
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    document.title = convertPtBR(document.title);
  };
  if (document.body) start(); else document.addEventListener("DOMContentLoaded", start);
}
